import { useQuery } from "react-query";
import { CompetitionAPI } from "api/admin/competition";
import { COMPETITIONS } from "helpers/constants";

export default function useCompetition(id) {
  return useQuery([COMPETITIONS, id], () => CompetitionAPI.getCompetition(id), {
    enabled: !!id,
  });
}
